import { render } from "./pod.vue?vue&type=template&id=46452a8f&scoped=true"
import script from "./pod.vue?vue&type=script&lang=js"
export * from "./pod.vue?vue&type=script&lang=js"

import "./pod.vue?vue&type=style&index=0&id=46452a8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46452a8f"]])

export default __exports__